import React from "react";
import PropTypes from "prop-types";

import { IS_DEBUG } from "@home/config";

/**
 * withDataTestId is a higher-order component that wraps any component,
 * injecting a required data-testid prop.
 *
 * @param {React.ComponentType} WrappedComponent - The component to wrap.
 * @returns {React.ForwardRefExoticComponent} A component that requires a dataTestId prop.
 */
const withDataTestId = (WrappedComponent) => {
  const ComponentWithTestId = React.forwardRef(({
    dataTestId,
    "data-testid": dataTestIdAttr,
    className,
    ...props
  }, ref) => {
  
    const resolvedDataTestId = dataTestIdAttr ?? dataTestId;

    if (IS_DEBUG === "true" && resolvedDataTestId == null) {
      // Warn in debug mode without throwing to avoid disrupting render flow.
      console.warn("Testable component requires either dataTestId or data-testid.");
    }

    return (
      <WrappedComponent
        ref={ref}
        {...props}
        data-testid={resolvedDataTestId}
        className={className}
      />
    );
  });

  ComponentWithTestId.propTypes = {
    dataTestId: PropTypes.string,
    "data-testid": PropTypes.string,
    className: PropTypes.string,
  };

  return ComponentWithTestId;
};


export default withDataTestId;